import {
  FuelType,
  LabourRateType,
  TyreAxlePosition,
  TyrePosition,
  TyreStatusType,
  TyreType,
  VatType,
  VehicleType,
  WorkorderLineType
} from '@cbgms/api'
import { OdometerType } from '@carsys/enums/odometer-type'
import { TyreSpeedIndex } from '@carsys/enums/tyre-speed-index'

export enum AdapterType {
  rob = 'rob_nl'
}

export enum LocationType {
  AllTyresAreEqual = 'all_tyres_are_equal',
  TyresAreDifferent = 'tyres_are_different',
  PositionUnknown = 'position_unknown'
}

export enum LeaseWorkorderLineStatus {
  None = 'none',
  Modified = 'modified',
  Pending = 'pending',
  Cancelled = 'cancelled',
  Archived = 'archived',
  Deleted = 'deleted',
  Unknown = 'unknown'
}

export enum LeaseContractStatus {
  Active = 'active',
  Inactive = 'inactive',
  Expired = 'expired',
  Revoked = 'revoked',
  Pending = 'pending',
  Unknown = 'unknown'
}

export enum LeaseServiceOrderStatus {
  Draft = 'draft',
  Approved = 'approved',
  Rejected = 'rejected',
  Invoiced = 'invoiced',
  InReview = 'in_review',
  Modified = 'modified',
  ActionRequired = 'action_required',
  Deleted = 'deleted',
  Internal = 'internal'
}

export enum LeaseServiceOrderLineAction {
  ContactLeaseCompany = 'contact_leasecompany',
  AwaitLeaseCompanyContact = 'await_leasecompany_contact',
  LineDeletionAllowed = 'line_deletion_allowed',
  LineDeletionNotAllowed = 'line_deletion_not_allowed',
  AwaitProviderAction = 'await_provider_action',
  None = 'none',
  Unknown = 'unknown'
}

export enum LeaseRemarkType {
  Maintenance = 'maintenance_remark',
  ReliefVehicle = 'relief_vehicle_remark',
  VehicleCondition = 'condition_remark',
  Tyres = 'tyre_remark',
  General = 'general_remark',
  Driver = 'driver_remark',
  SpecialContractConditions = 'contract_remark',
  LeaseCompanyRemark = 'lease_company_remark',
  SupplierRemark = 'supplier_remark'
}

export enum LeaseTyreExpense {
  Costs_Storage = 'storage_costs',
  Costs_Service = 'service_costs',
  Costs_Transport = 'transport_costs',
  Handling_Storage = 'storage_handling_costs',
  Handling_ThirdPartyTyre = 'third_party_tyre_handling_costs',
  Fee_Disposal = 'disposal_fee',
  Fee_DealerDelivery = 'dealer_delivery_fee',
  Surcharge_Nitrogen = 'nitrogen_surcharge',
  Surcharge_RonOnFlat = 'run_on_flat_surcharge',
  Surcharge_LargeRim = 'large_rim_surcharge',
  Surcharge_MobileServices = 'mobile_services_surcharge',
  Surcharge_TruckTyre = 'truck_tyre_surcharge',
  Trim = 'trim',
  Tyre_Match = 'tire_match',
  Regroove = 'regroove',
  Balance = 'balance',
  Exchange = 'exchange'
}

export enum TyreRollingResistanceType {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
  None = ''
}

export enum TyreTractionType {
  High = 'AA',
  Medium = 'A',
  Low = 'B',
  Lower = 'C',
  Unrated = ''
}

export enum LeaseServiceRule {
  Allowed = 'allowed',
  Mandatory = 'mandatory',
  RequestPermission = 'request_permission',
  PrivateOnly = 'private_only',
  NotAllowed = 'not_allowed',
  Undetermined = 'not_determined',
  OnlyByBrandDealer = 'brand_dealer_only',
  OnlyByTyreSpecialist = 'tyre_specialist_only'
}

export enum LeaseServicePermission {
  Maintenance = 'maintenance',
  ReliefVehicle = 'relief_vehicle',
  Tyres = 'tyres',
  TyresSwap = 'tyres_swap',
  TyresReplace = 'tyres_replace',
  TyresWithoutMounting = 'tyres_no_mount',
  TyresWinter = 'tyres_winter',
  TyresUsed = 'tyres_used',
  TyresAllSeason = 'tyres_allseason',
  TyresRunOnFlat = 'tyres_rof',
  TyresNitrogen = 'tyres_nitro',
  DeliveryCosts = 'delivery',
  PickupCosts = 'pickup',
  FillupCosts = 'fill_up',
  ProfileDepthExemption = 'profile_depth_exemption'
}

export enum TyreActivityAction {
  SeasonChange = 3199,
  TyreReplacement = 3198,
  TyreRepair = 3197,
  TyreWithoutMount = 3196
}

export enum RentalOptions {
  RentalPeriod = 9110,
  RentalPeriodCharged = 9111,
  FreeKilometrage = 9112,
  RentalPeriodKilometrage = 9113,
  RentalChargeTotal = 9150,
  MiscellaneousCharges = 9153,
  KilometrageSurcharge = 9154,
  FuelCharge = 9155,
  SurchargeRatePerKilometer = 9157,
  DeductibleClaim = 9158
}

export enum TyreConstructionType {
  R = 'R',
  D = 'D',
  B = 'B',
  ZR = 'ZR'
}

export enum TyreVehicleDesignation {
  P = 'P',
  LT = 'LT',
  ST = 'ST',
  T = 'T'
}

export enum NodeType {
  Operation = 'operation',
  Reason = 'reason',
  Price = 'price',
  WDL = 'wdl',
  Location = 'location',
  PartCount = 'part_count',
  Code = 'code',
  Defect = 'defect',
  Value = 'value',
  Part = 'part',
  Comment = 'comment'
}

export enum GenericType {
  Total = 'total',
  PartCount = 'part_count',
  WheelOnAxle = 'wheel_on_axle',
  PerUnit = 'per-unit',
  Tyre = 'tire',
  ProfileDepthInMM = 'profile_depth_in_mm',
  ReplacementVehicleDelivery = 'replacement-vehicle-delivery',
  RentalClass = 'rental_class',
  Duration = 'duration',
  Distance = 'distance',
  ReplacementVehicle = 'replacement-vehicle',
  PhoneNumber = 'phone_number',
  Name = 'name',
  Street = 'street',
  StreetNumber = 'street_number',
  StreetNumberSuffix = 'street_number_suffix',
  PostalCode = 'postalcode',
  City = 'city',
  FuelType = 'fuel_type',
  AutomaticTransmission = 'automatic_transmission',
  Estate = 'estate',
  Consumption = 'consumption'
}

export enum ProductReferenceCodeType {
  Genart = 'genart',
  Hbase = 'hbase',
  Emdm = 'emdm'
}

export enum LeasePriceObjectType {
  Component = 'component',
  Part = 'part',
  Labour = 'labour',
  Discount = 'discount',
  Addition = 'addition'
}

export enum AmountUnit {
  Liter = 'liter',
  Kilogram = 'kilogram',
  Gram = 'gram',
  Piece = 'piece',
  Hour = 'hour',
  Total = 'total',
  Percentage = 'percentage'
}

export enum HQLeaseDiscountType {
  Default = 'default',
  Tyres = 'tyres',
  TyreMount = 'tyre_mount',
  ReliefVehicle = 'relief_vehicle'
}

interface Remark {
  RemarkType: LeaseRemarkType
  Remark: string
}

interface ContractTermination {
  EndDate: string
  MaximumMileage: number
  Remark: Remark
}

interface LeaseCompany {
  ID: string
  Code: string
  ChildCode: string
}

interface Vehicle {
  Registration: string
  FuelType: FuelType[]
  VehicleType: VehicleType
  Manufacturer: string
  Model: string
  Type: string
}

interface TyreExpense {
  Type: LeaseTyreExpense
  MaximumCost: number
  Rule: LeaseServiceRule
  VatType: VatType
}

export interface TyreIdentifier {
  Description: string
  AdapterAssignedCode: string
  BACCode: string
  Manufacturer: string
  ManufacturerCode: string
  EANCode: string
  TypeNumber: number
  ModelTypeProfile: string
}

export interface TyreTechnicalData {
  Width: number
  RimDiameter: number
  AspectRatio: number
  Type: TyreType
  LoadIndex: number
  SpeedIndex: string
  NoiseOutputLevelInDecibels: number
  RollingResistanceType: TyreRollingResistanceType
  TractionType: TyreTractionType
  IsRunFlat: boolean
  RecommendedRetailPrice: number
  IsCurrent: boolean
  NotCurrentSinceYear: number
}

interface FittingPosition {
  Axle: TyreAxlePosition
  Position: TyrePosition
  Remark: Remark
}

export interface Tyre {
  Identification: TyreIdentifier
  Specification: TyreTechnicalData
  TyreStatus: TyreStatusType
  FittingPosition: FittingPosition
  LastKnownThreadDepth: number
}

interface TyreArrangement {
  Expenses: TyreExpense[]
  Tyres: Tyre[]
  WinterSetPurchased: boolean
}

interface ReliefVehicleArrangement {
  MaximumClassAcriss: string
  MaximumClassCode: string
}

interface Maintenance {
  NextPeriodicDate: string
  LastMaintenanceDate: string
  LastMaintenanceMileageCode: string
  LastMaintenanceMileage: number
}

export interface LabourRate {
  Code: string
  Description: string
  HourlyRate: number
  VatType: VatType
}

interface ServicePermission {
  Type: LeaseServicePermission
  MaximumCost: number
  Rule: LeaseServiceRule
  VatType: VatType
}

export interface LeaseCompanyContractModal {
  Status: LeaseContractStatus
  Termination: ContractTermination
  LeaseCompany: LeaseCompany
  Vehicle: Vehicle
  Tyres: TyreArrangement
  ReliefVehicle: ReliefVehicleArrangement
  Maintenance: Maintenance
  Services: ServicePermission[]
  LabourRates: LabourRate[]
  Remarks: Remark[]
}

export interface LeaseCompanyContractRequest {
  Data: LeaseCompanyContractModal
}

export interface LeaseCompanyUserModal {
  APIKey: string
  CreatedAt: string
  IsActive: boolean
  Password: string
  ShopID: string
  UUID: string
  UpdatedAt: string
  UserID: string
  Username: string
  DisplayName: string
  BranchUUID: string
}

export interface LeaseCompanyUsersModal {
  User: LeaseCompanyUserModal
  BranchFormula: LeaseCompanyBranch
}

export interface LeaseCompanyUsersRequest {
  Data: LeaseCompanyUsersModal[]
}

export interface LeaseCompanyCreateUserData {
  Error?: string
  BranchUUID: string
  UserID: string
  Username: string
  DisplayName: string
  Password: string
  APIKey: string
}

export interface LeaseCompanyUserUUIDRequest {
  Data: {
    UUID: string
  }
}

export interface LeaseCompanyExistsRequest {
  Data: {
    Exists: boolean
  }
}

export interface LeaseCompanyServiceOrderLineDeleteRequest {
  Data: {
    LineDeleted: boolean
  }
}

export interface LeaseCompanyUserRequest {
  Data: LeaseCompanyUsersModal
}

export interface LeaseCompanyDeleteUser {
  Rejections: any
  Warnings: any
}

export interface LeaseCompanyDeleteUserRequest {
  Data: LeaseCompanyDeleteUser
}

export interface LeaseCompanyBranch {
  UUID: string
  CreatedAt: string
  UpdatedAt: string
  AdapterType: AdapterType
  Name: string
}

export interface LeaseCompanyAllBranchRequest {
  Data: LeaseCompanyBranch[]
}

export interface LeaseCompanyBranchRequest {
  Data: LeaseCompanyBranch
}

export interface LeaseCompanySearch {
  ID: string
  Description?: string
  idArr?: string[]
  Priority?: boolean
}

export interface LeaseCompanySearchModal {
  Results: LeaseCompanySearch[]
  Total: number
}

export interface LeaseCompanySearchRequest {
  Data: LeaseCompanySearchModal
}

export interface SubNode {
  Description?: string
  ID: string
}

export interface GenericSubNodes {
  Type?: GenericType
  NodeType?: NodeType
  GenericSubNodes?: SubNode[]
  IsRequired?: boolean
  ID?: string
  Description?: string
  IsSelected?: boolean
  HasDecimals?: boolean
  Value?: number
  ValueBool?: boolean
  ValueString?: string
}

export interface GenericNode {
  Description?: string
  ID?: string
  IsRequired: boolean
  NodeType: NodeType
  GenericSubNodes?: GenericSubNodes[]
  MaxValue?: number
  MinValue?: number
  Type?: GenericType
  HasDecimals?: boolean
  Value?: number
  IsSelected?: boolean
  ValueBool?: boolean
  ValueString?: string
}

export interface LeaseCompanyNode {
  GenericComponents: LeaseCompanyComponent
  GenericNodes: GenericNode[]
}

interface Rejections {
  ID: string
  Remark: string
}

interface StatusNode {
  ID: LeaseServiceOrderStatus
  Description: string
  GenericRejections?: Rejections[]
}

export interface LeaseCompanyComponentModal {
  HeaderSection: SubNode
  ContentSection: LeaseCompanyNode
  IsSelected?: boolean
  StatusNode?: StatusNode
  UUID?: string
}

export interface LeaseCompanyComponent {
  [id: string]: LeaseCompanyComponentModal[]
}

export interface LeaseCompanyComponentRequest {
  Data: LeaseCompanyComponent
}

export interface LeaseCompanyServiceOrderModal {
  UUID: string
  ShopID: string
  CreatedAt: string
  UpdatedAt: string
  AdapterType: AdapterType
  ExternalReferenceID: string
  Status: LeaseServiceOrderStatus
  PublishCounter: number
  Remarks: Remark[]
  ReferenceUUID: string
  ServiceStartedAt: string
  Registration: string
  Vin: string
  PartialVIN: string
  Make: string
  Model: string
  Type: string
  OdometerUnit: OdometerType
  OdometerValue: number
  Remark: string
  ServiceEndedAt: string
  UserUUID: string
  Requestor: string
}

export interface LeaseCompanyUpdateServiceOrderData {
  Error?: string
  Remark?: string
  ServiceEndedAt?: string
  OdometerUnit?: OdometerType
  OdometerValue?: number
  PartialVin?: string
  UserUUID?: string
  Vin?: string
  LastMaintenanceCode?: string
  ServiceStartedAt?: string
  Requestor?: string
}

export interface LeaseCompanyServiceOrderRequest {
  Data: LeaseCompanyServiceOrderModal
}

export interface LeaseCompanyServiceOrderLineModal {
  UUID: string
  ShopID: string
  CreatedAt: string
  UpdatedAt: string
  ServiceOrderUUID: string
  Status: LeaseServiceOrderStatus
  RequiredAction: LeaseServiceOrderLineAction
  AdapterType: AdapterType
  ComponentID: string
  ReferenceUUID: string
  Component: LeaseCompanyComponent
}

export interface LeaseCompanyServiceOrderLinesRequest {
  Data: LeaseCompanyServiceOrderLineModal[]
}

export interface LeaseCompanyServiceOrderLineRequest {
  Data: LeaseCompanyServiceOrderLineModal
}

export interface LeaseCompanyCreateServiceOrder {
  Error: string
  ReferenceUUID: string
  Reference: string
  ServiceStartedAt: string
  ServiceEndedAt: string
  Remark: string
  Registration: string
  Vin: string
  PartialVin: string
  Make: string
  Model: string
  Type: string
  OdometerUnit: OdometerType
  OdometerValue: number
}

export interface LeaseCompanyUpdateServiceOrderLine {
  Error: string
  Component: LeaseCompanyComponent | {}
  ReferenceUUID?: string
  DuplicatedServiceOrderLineUUID?: string
}

export interface LeaseCompanyCreateServiceOrderLine extends LeaseCompanyUpdateServiceOrderLine {
  ReferenceUUID: string
}

interface TyreSpcifications {
  ID: string
  Description: string
  BACCode: string
  MakeCode: string
  EANCode: string
  ModelTypeProfile: string
  TypeNumber: number
  NoiseDecibelLevel: number
  RollingResistanceType: TyreRollingResistanceType
  TractionType: TyreTractionType
  SuggestedRetailPrice: number
  IsCurrent: boolean
  NotCurrentSinceYear: number
}

export interface LeaseCompanyTyreModal {
  Make: string
  Model: string
  Width: number
  AspectRatio: number
  ConstructionType: TyreConstructionType
  RimDiameter: number
  LoadIndex: number
  SpeedIndex: TyreSpeedIndex
  DesignationType: TyreVehicleDesignation
  SeasonalType: TyreType
  IsRunFlat: boolean
  Details: TyreSpcifications
}

export interface LeaseCompanyTyreSearchModal {
  Results: LeaseCompanyTyreModal[]
  Total: number
}

export interface LeaseCompanySearchForTyresRequest {
  Data: LeaseCompanyTyreSearchModal
}

export interface LeaseCompanySpecificTyreRequest {
  Data: LeaseCompanyTyreModal
}

export interface LeaseCompanyServiceOrderStatusModal {
  ShopID: string
  AdapterType: AdapterType
  Registration: string
  ReferenceUUID: string
  LastLocalChangeAt: string
  LastRemoteChangeAt: string
  PreviousStatus: LeaseServiceOrderStatus
  NewStatus: LeaseServiceOrderStatus
  AmountApproved: number
  AmountToInvoice: number
  AmountInvoiced: number
}

export interface LeaseCompanyServiceOrderStatusesRequest {
  Data: LeaseCompanyServiceOrderStatusModal[]
}

export interface LeaseCompanyFixedPrice {
  LineType: WorkorderLineType
  GenericReferenceID: string
  ArticleReferenceType?: ProductReferenceCodeType
  LabourReferenceType?: LabourRateType
}

export interface LeaseCompanyFixedPriceModal {
  ObjectTypes: LeasePriceObjectType[]
  ID: string
  Description: string
  IsPercentage: boolean
  IsDiscount: boolean
  Amount: number
  AmountUnit: AmountUnit
  VatType: VatType
  ArticleCodes: null
}

export interface LeaseCompanyFixedPriceRequest {
  Data: LeaseCompanyFixedPriceModal[]
}

export interface LeaseCompanyInvoiceSummaryRequest {
  Data: LeaseCompanyInvoiceSummaryModal
}

export interface LeaseCompanyInvoiceSummaryModal {
  BaseTotalVATExcluded: number
  HQTotalVATAmount: number
  HQTotalVATExcluded: number
  HQTotalVATIncluded: number
  ReferenceUUID: string
  VATLines: VATLine[]
  Discounts: Discount[]
}

export interface Discount {
  Percentage: number
  DiscountType: HQLeaseDiscountType
}

export interface VATLine {
  VATPercentage: number
  VATAmount: number
  VATExcluded: number
}
